import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';
import { EventBus } from '@vtblife/event-bus';
var eventBus = EventBus.getInstance();
export var DEFAULT_REGION = {
  userRegionId: 3,
  userRegionName: 'Москва'
};
var eventTypes = [{
  type: 'userRegion:change',
  category: 'simple'
}, {
  type: 'userRegion:init',
  category: 'behavior'
}, {
  type: 'userRegion:update',
  category: 'behavior'
}];
export function useUserRegion(defaultRegion) {
  var _useState = useState(defaultRegion),
    _useState2 = _slicedToArray(_useState, 2),
    region = _useState2[0],
    setRegion = _useState2[1];
  useEffect(function () {
    var subscriptions = eventTypes.map(function (_ref) {
      var type = _ref.type,
        category = _ref.category;
      var subscription = eventBus.subscribe(type, function (event) {
        setRegion(event.data);
      }, {
        eventCategory: category
      });
      return subscription;
    });
    return function () {
      return subscriptions.forEach(function (sub) {
        return sub.unsubscribe();
      });
    };
  }, []);
  return region;
}